import { WhoAmIRead } from "@/services/generatedApi";
import { createSlice } from "@reduxjs/toolkit";
import type { PayloadAction } from "@reduxjs/toolkit";

export interface TenantPreview {
  name: string;
  id: string;
}

export interface AuthState {
  token: string | null;
  userId: string | null;
  user: WhoAmIRead | null;
  tenant: TenantPreview | null;
  groups: string[] | null;
}
export interface RootAuthState {
  auth: AuthState;
}

const initialState = {
  token: null,
  tenantId: null,
  groups: [],
  userId: null,
  user: null,
  tenant: null,
} as AuthState;

export const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    setToken(state, action: PayloadAction<string>) {
      state.token = action.payload;
    },
    setUser(state, action: PayloadAction<WhoAmIRead>) {
      state.user = action.payload;
      state.userId = action.payload.id;
    },
    setTenant(state, action: PayloadAction<{ name: string; id: string }>) {
      const { id, name } = action.payload;
      state.tenant = { name, id };
    },
    setGroups(state, action: PayloadAction<string[] | null>) {
      state.groups = action.payload;
    },
  },
});

export const { setToken, setUser, setGroups, setTenant } = authSlice.actions;
export const authReducer = authSlice.reducer;
